// extracted by mini-css-extract-plugin
module.exports = {"cardPart":"CrossSegmentCard-CardPart-module--card-part--2LreA"};